import './new-user-popup.scss'
import { FC, useState } from "react"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { InputSwitch } from "primereact/inputswitch"
import { useDispatch, useSelector } from 'react-redux'
import { createUser, updateUser } from 'features/authentication/userSlices'
import { useFormik } from 'formik'
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
import * as Yup from "yup";
import { strict } from 'assert'

interface NewUserPopupProps {
    isVisible:boolean,
    setVisible:Function,
    userToEdit: any,
    setUserToEdit:Function
}
interface UserFormProps{
  name: string;
  lastname: string;
  email: string;
  position: number;
  shops:string[];
}
const validationSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  lastname: Yup.string().required("Required"),
  email: Yup.string().email().required("Required"),
  position:  Yup.number().required("Required"),
  shops: Yup.array().of(Yup.string()).min(1, "Select at least one shop").required("Required")
});

const items = [
  { name: 'Employee', value: 1 },
  { name: 'Manager', value: 2 },
  { name: 'Super Manager', value: 3 }
];
const getName = (name) => {
  const item = items.find(item => item.name === name);
  return item ? item.value : 1;
}
const markMissingItems = (arr1, arr2) => {
  return arr1.map(item1 => {
      const exists = arr2.some(item2 => item2.id === item1.id);
      return exists ? item1 : { ...item1, disabled: true };
  });
}
const NewUserPopup : FC<NewUserPopupProps>= ({isVisible,setVisible, userToEdit, setUserToEdit}) => {
    const user = useSelector((state: any) => state.auth.user);
    const users = useSelector((state: any) => state.user.users);
    const detailedShops = useSelector((state: any) => state.shop.detailedShops);
    const connectedUserFromTable = users.find(u => u.id == user.id).shops
    const options = markMissingItems(detailedShops, connectedUserFromTable)
    const dispatch: Function = useDispatch();
    const initialValues = userToEdit ? {
      name: userToEdit.name.split(' ')[0] ,
      lastname: userToEdit.name.split(' ')[1],
      email: userToEdit.email,
      position: userToEdit.position,
      shops:userToEdit.shops.map(s=>s.id),
    } : {
      name: "",
      lastname:  "",
      email: "",
      position: 1,
      shops:[],
    }
    const formik = useFormik<UserFormProps>({
      initialValues:initialValues,
      validateOnMount: true,
      validationSchema,
      onSubmit: (newUser) => {
        if(userToEdit){
          newUser['id'] = userToEdit.user_id
          dispatch(updateUser(newUser, user.sub))
          setUserToEdit(null)
        }else{
          dispatch(createUser(newUser, user.sub));
        }
        setVisible(false)
      },
    });

    const handleClose = () =>{
      formik.resetForm()
      setVisible(false)
      setUserToEdit(null)
    }
    return (
      <>
      <div className="mask"></div>
      <div className="popup">
        <div className={`new-user-popup ${isVisible || userToEdit? 'visible' : ''}`}>
          <div className="new-user-popup__header">
            <div className="new-user-popup__header__titles">
              <div className="new-user-popup__header__titles__title">{userToEdit ? 'Edit user' : 'Add user'}</div>
              <div className="new-user-popup__header__titles__subtitle">{userToEdit ? 'Edit a user of your float' : 'Add new user to your float'}</div>
            </div>
            <Button onClick={() =>handleClose()} icon="pi pi-times" iconPos='right' className="new-user-popup__header__close-button" />
          </div>
          <div className="new-user-popup__content">
            <div className="new-user-popup__content__title">Name</div>
            <InputText name="name" value={formik.values.name} onChange={formik.handleChange} placeholder='Name'/>
            <div className="new-user-popup__content__title">Last Name</div>
            <InputText name="lastname" value={formik.values.lastname} onChange={formik.handleChange} placeholder='Last Name'/>
            <div className="new-user-popup__content__title">Email address</div>
            <InputText  name="email" value={formik.values.email} onChange={formik.handleChange} placeholder='Email address'/>
            <div className="new-user-popup__content__title">Position</div>
            <SelectButton value={formik.values.position} onChange={formik.handleChange} name="position" optionLabel="name" options={items} />
            <div className="new-user-popup__content__title">Shops</div>
            <MultiSelect name="shops" value={formik.values.shops} onChange={formik.handleChange} itemClassName='multi-select-item' panelClassName='multi-select-panel' options={options} optionLabel="name" optionValue='id' placeholder="Select a shop" 
                display="chip" className="shop-dropdown"
                />
          </div>
          <div className="new-user-popup__footer">
            <Button onClick={() => handleClose()} iconPos='right' label={'Cancel'} className="new-user-popup__footer__cancel-button" />
            <Button onClick={() => formik.handleSubmit()} iconPos='right' disabled={!formik.isValid} label={'Confirm'} className="new-user-popup__footer__confirm-button" />
          </div>
        </div>
      </div>
      </>
    )
}

export default NewUserPopup